import { Link } from 'react-router-dom';
import { Mail, BookOpen, Shield } from 'lucide-react';
import styles from './Footer.module.css';
export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* À propos */}
          <div className={styles.section}>
            <h3 className={styles.title}>
              <BookOpen size={18} />À propos de PokeFolio
            </h3>
            <p className={styles.description}>
              PokeFolio est votre gestionnaire de collection de cartes Pokémon. Suivez la valeur de
              vos cartes, gérez vos gradations et partagez votre collection avec vos amis.
            </p>
            <a
              href="https://paypal.me/mattheonaegellen"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.donationLink}
            >
              <img
                src="/assets/paypal-logo-png-transparent.png"
                alt="PayPal"
                className={styles.paypalIcon}
              />
              <span>Soutenir le projet</span>
            </a>
          </div>

          {/* Liens utiles */}
          <div className={styles.section}>
            <h3 className={styles.title}>
              <Shield size={18} />
              Informations légales
            </h3>
            <nav className={styles.links}>
              <Link to="/terms" className={styles.link}>
                Conditions d&apos;utilisation
              </Link>
              <Link to="/privacy" className={styles.link}>
                Politique de confidentialité
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className={styles.section}>
            <h3 className={styles.title}>
              <Mail size={18} />
              Nous contacter
            </h3>
            <div className={styles.contact}>
              <p className={styles.contactText}>Une question ? Une suggestion ?</p>
              <a href="mailto:contact@pokefolio.xyz" className={styles.contactEmail}>
                contact@pokefolio.xyz
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className={styles.bottom}>
          <p className={styles.copyright}>© {currentYear} PokeFolio. Tous droits réservés.</p>
          <p className={styles.disclaimer}>
            Pokémon et les noms de Pokémon sont des marques déposées de Nintendo, Creatures Inc. et
            GAME FREAK Inc. Ce site n&apos;est pas affilié à The Pokémon Company.
          </p>
        </div>
      </div>
    </footer>
  );
}
